/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Table, Switch } from 'antd';
import { FaPen } from 'react-icons/fa';
import usePaginationHook from '../../../../utils/usePagination';
import { useQueryClient } from '@tanstack/react-query';
import fitLegacyServices from '../../../../services/fit-legacy.services';
import { AlertSuccess } from '../../../util/Alert';
import LegacyCategorySettingModal from '../modal/LegacyCategorySettingModal';

const pageSize = 10;

const LegacyCategorySettingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  const {
    data: settingLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  const queryClient = useQueryClient();

  fitLegacyServices.useQueryGetLegacyFitApiSettings(
    {
      take: pageSize,
      page,
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const _HandleEdit = (record) => {
    setEditRecord(record);
    setModalOpen(true);
  };

  const { mutate: updateIsShow } =
    fitLegacyServices.useMutationUpdateLegacyFitApiSettingIsShow((data) => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-fit-api-setting'],
        refetchType: 'all',
      });
      AlertSuccess(data.isShow ? 'เปิดการแสดงผลสำเร็จ' : 'ปิดการแสดงผลสำเร็จ');
    });

  const _HandleToggleIsShow = (record, checked) => {
    updateIsShow({ id: record.id, isShow: checked });
  };

  const _HandleModalClose = () => {
    setEditRecord(null);
    setModalOpen(false);
    queryClient.invalidateQueries({
      queryKey: ['get-legacy-fit-api-setting'],
      refetchType: 'all',
    });
  };

  const renderBooleanIcon = (value) => (
    <span
      style={{
        color: value ? '#52c41a' : '#ff4d4f',
        fontWeight: 500,
      }}
    >
      {value ? 'เปิด' : 'ปิด'}
    </span>
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      render: (_, record) => (
        <span>
          {record.category === 'LegacyMission' && 'LegacyCorp ยิ่งทำยิ่งได้'}
          {record.category === 'LegacyQuiz' && 'LegacyCorp Skill Up'}
          {record.category === 'LegacyCheckinBranch' &&
            'LegacyCorp ภารกิจเช็คอินสาขา'}
          {record.category === 'LegacyPVM' && 'Legacy PVM'}
        </span>
      ),
    },
    {
      title: 'ผู้ใช้งานทั่วไป (Guest)',
      dataIndex: 'Guest',
      key: 'Guest',
      render: (_, record) => renderBooleanIcon(record.Guest),
    },
    {
      title: 'นักธุรกิจรหัสหลัก',
      dataIndex: 'Distributor',
      key: 'Distributor',
      render: (_, record) => renderBooleanIcon(record.Distributor),
    },
    {
      title: 'นักธุรกิจรหัสร่วม',
      dataIndex: 'isPartner',
      key: 'isPartner',
      render: (_, record) => renderBooleanIcon(record.isPartner),
    },
    {
      title: 'VIP Member',
      dataIndex: 'Member',
      key: 'Member',
      render: (_, record) => renderBooleanIcon(record.Member),
    },
    {
      title: 'แสดงผล',
      dataIndex: 'isShow',
      key: 'isShow',
      render: (_, record) => (
        <Switch
          checked={record.isShow}
          onChange={(checked) => _HandleToggleIsShow(record, checked)}
          checkedChildren="เปิด"
          unCheckedChildren="ปิด"
        />
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'flex-end' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => _HandleEdit(record)}
          >
            <FaPen />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Panel>
      <PanelHeader>Category Setting</PanelHeader>
      <PanelBody>
        <Table
          columns={columns}
          dataSource={settingLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          onChange={({ current }) => {
            setPage(current);
          }}
          pagination={{
            pageSize,
            total,
          }}
        />
      </PanelBody>
      {modalOpen && (
        <LegacyCategorySettingModal
          open={modalOpen}
          handleClose={_HandleModalClose}
          record={editRecord}
        />
      )}
    </Panel>
  );
};

export default LegacyCategorySettingPage;
